
export const pathList = [
    { name: "Teamtool", path: "app", description: "Add a description" }, 
    { name: "Audit", path: "audit", description: "Add a description" }, 
    { name: "EDI", path: "edi", description: "Add a description" }, 
    { name: "OTP", path: "otp", description: "Add a description" },
  ];


